import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { PagedResponse } from '../../domain/response/paged-response';

@Injectable()
export class ReportLatestWeightService {
  protected http = inject(HttpClient);


  public search(criteria: any): Observable<PagedResponse> {
    return this.http.post<PagedResponse>(
      '/api/report/latestweight/report',
      criteria
    );
  }
}
